import Vue from 'vue'
import axios from "axios"
import Qs from 'qs'


axios.defaults.headers['Content-Type'] = 'application/json'

function handleResponse(res) {
    if (res.status == 200) {
        return Promise.resolve(res.data)
    } else {
        // 在Ie9中，没有Http状态码返回
        if (res.data) {
            return Promise.resolve(res.data)
        } else {
            console.log('error');
            return Promise.resolve(res)
        }
    }
}

function get(url, query) {
    const data = Qs.stringify(query);
    return axios.get(url, data).then(handleResponse)
}

function post(url, query) {
    // const data = Qs.stringify(query);
    return axios.post(url, query).then(handleResponse)
}

export default {
    get,
    post
}


// WEBPACK FOOTER //
// ./src/util/http.js